import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// content-1.twig
import React from 'react';
import styled from 'styled-components';
import { Headline, Content } from '@miro-site/components_utils';
import { AccordionButton, Section, UnorderedList, ListItem, Container, Box, Centered } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AccordionWrapper = styled(Box).attrs({
  as: 'ul',
  $mt: [40, 80],
  $styles: {
    listStyle: 'none'
  }
}).withConfig({
  displayName: "Faq__AccordionWrapper",
  componentId: "sc-1hy8t75-0"
})([""]);

var Faq = function Faq(_ref) {
  var headline = _ref.headline,
      items = _ref.items,
      sectionId = _ref.sectionId;
  return /*#__PURE__*/_jsx(Section, {
    "data-place": "FAQ section",
    type: "large",
    id: sectionId,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [(headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Centered, {
        children: /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
          size: headline.size || 'mid',
          tag: headline.tag || 'h2'
        }))
      }), (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_jsx(AccordionWrapper, {
        children: items.map(function (item, index) {
          var _item$headline;

          if (!((_item$headline = item.headline) !== null && _item$headline !== void 0 && _item$headline.text)) {
            return null;
          }

          var content = item.content && /*#__PURE__*/_jsx(Content, _objectSpread({}, item.content));

          if (!content && item.list) {
            content = /*#__PURE__*/_jsx(UnorderedList, {
              $variant: "default",
              children: item.list.map(function (listItem, index) {
                return /*#__PURE__*/_jsx(ListItem, {
                  children: listItem
                }, index);
              })
            });
          }

          return /*#__PURE__*/_jsx(AccordionButton, {
            id: index + '',
            showContentInDom: true,
            defaultExpanded: index == 0,
            headline: /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, item.headline), {}, {
              size: item.headline.size || 'tiny',
              tag: item.headline.tag || 'div'
            })),
            content: content
          }, index);
        })
      })]
    })
  });
};

Faq.defaultProps = {
  headline: {
    text: 'FAQ',
    size: 'medium',
    align: 'center'
  }
};
export default Faq;